// extracted by mini-css-extract-plugin
export default {"page":"jP","freeShippingContainer":"kP","customizeContainer":"lP","customizeHeader":"mP","fadein":"nP","customizeText":"oP","hidden":"pP","productcard":"qP","accordeonscontainer":"rP","freeShipping":"sP","mainpart":"tP"};
    if(module.hot) {
      // 1713211523320
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  